




























import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { nextTick } from '@/lib/nextTick';
import MessageTransition from './MessageTransition.vue';

export default defineComponent({
    props: {
        extended: Boolean,
    },
    setup(props) {
        const secondInput$ = ref<HTMLDivElement>(null);

        const labelInputHeight = ref(0);

        async function updateLabelInputHeight() {
            if (props.extended && secondInput$.value) {
                await nextTick();
                const input = secondInput$.value.querySelector('input');
                if (input) labelInputHeight.value = input.clientHeight;
                else labelInputHeight.value = 0;
            }
        }

        onMounted(updateLabelInputHeight);
        watch(() => props.extended, updateLabelInputHeight);

        return {
            secondInput$,
            labelInputHeight,
        };
    },
    components: {
        MessageTransition,
    },
});
